import createModel, { prop } from './lib/create_model';
const Audience = createModel({
  modelName: 'Audience',
  properties: {
    id: prop(String),
    name: prop(String),
    archived: prop(Boolean),
  },

  isArchived() {
    return Boolean(this.archived);
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default Audience;
